export var LoadDataType;
(function (LoadDataType) {
    LoadDataType["z3k_temperature"] = "z3k_temperature";
    LoadDataType["weather"] = "weather";
    LoadDataType["ztc_state"] = "ztc_state";
    LoadDataType["temperature"] = "temperature";
    LoadDataType["thermostat_work"] = "thermostat_work";
    LoadDataType["z3k_boiler_adapter"] = "z3k_boiler_adapter";
    LoadDataType["z3k_radio_sensor"] = "z3k_radio_sensor";
    LoadDataType["z3k_analog_input"] = "z3k_analog_input";
    LoadDataType["z3k_heating_circuit"] = "z3k_heating_circuit";
    LoadDataType["z3k_web_element"] = "z3k_web_element";
    LoadDataType["otzones"] = "otzones";
    LoadDataType["gtw_report"] = "gtw_report";
    LoadDataType["custom_controls"] = "custom_controls";
    LoadDataType["heatsettemp"] = "heatsettemp";
    LoadDataType["rf"] = "rf";
    LoadDataType["gps"] = "gps";
    LoadDataType["events"] = "events";
})(LoadDataType || (LoadDataType = {}));
///z3k_analog_input
var Z3kAnalogInputState;
(function (Z3kAnalogInputState) {
    Z3kAnalogInputState["voltage"] = "voltage";
    Z3kAnalogInputState["resistance"] = "resistance";
    Z3kAnalogInputState["pressure"] = "pressure";
    Z3kAnalogInputState["status"] = "status";
    Z3kAnalogInputState["value"] = "value";
    Z3kAnalogInputState["unit"] = "unit";
})(Z3kAnalogInputState || (Z3kAnalogInputState = {}));
///z3k_heating_circuit
var Z3kHeatingCircuitVarName;
(function (Z3kHeatingCircuitVarName) {
    Z3kHeatingCircuitVarName["setpoint_temp"] = "setpoint_temp";
    Z3kHeatingCircuitVarName["worktime"] = "worktime";
    Z3kHeatingCircuitVarName["status"] = "status";
    Z3kHeatingCircuitVarName["target_temp"] = "target_temp";
    Z3kHeatingCircuitVarName["mode_id"] = "mode_id";
    Z3kHeatingCircuitVarName["target_sensor_id"] = "target_sensor_id";
})(Z3kHeatingCircuitVarName || (Z3kHeatingCircuitVarName = {}));
export var ThermostatWorkVarName;
(function (ThermostatWorkVarName) {
    ThermostatWorkVarName["boiler_work_time"] = "boiler_work_time";
    ThermostatWorkVarName["thermostat_mode"] = "thermostat_mode";
    ThermostatWorkVarName["target_temp"] = "target_temp";
    ThermostatWorkVarName["power"] = "power";
    ThermostatWorkVarName["fail"] = "fail";
    ThermostatWorkVarName["gate"] = "gate";
    ThermostatWorkVarName["dhw_t"] = "dhw_t";
    ThermostatWorkVarName["pza_t"] = "pza_t";
})(ThermostatWorkVarName || (ThermostatWorkVarName = {}));
///z3k_radio_sensor
var Z3kRadioSensorState;
(function (Z3kRadioSensorState) {
    Z3kRadioSensorState["temperature"] = "temperature";
    Z3kRadioSensorState["battery"] = "battery";
    Z3kRadioSensorState["dbm"] = "dbm";
    Z3kRadioSensorState["humidity"] = "humidity";
    Z3kRadioSensorState["flags"] = "flags";
})(Z3kRadioSensorState || (Z3kRadioSensorState = {}));
///gtw_report
export var GtwReportState;
(function (GtwReportState) {
    GtwReportState["oven_mode"] = "oven_mode";
    GtwReportState["oven_heat"] = "oven_heat";
    GtwReportState["fails"] = "fails";
    GtwReportState["ten_count"] = "ten_count";
    GtwReportState["t_air_int"] = "t_air_int";
    GtwReportState["t_air_ext"] = "t_air_ext";
    GtwReportState["t_water"] = "t_water";
    GtwReportState["t_water_setdisp"] = "t_water_setdisp";
    GtwReportState["t_air_setdisp"] = "t_air_setdisp";
    GtwReportState["p_water"] = "p_water";
    GtwReportState["thermostat_air"] = "thermostat_air";
    GtwReportState["thermostat_gvs"] = "thermostat_gvs";
})(GtwReportState || (GtwReportState = {}));
